import { gql } from '@apollo/client';

export const UPDATE_CORPORATE_ACCOUNT_PREFERENCE = gql`
  mutation patchCorporateAccountPreference(
    $input: CorporateAccountPreferenceInput
  ) {
    updateCorporateAccountPreference(input: $input)
  }
`;
